export default function isStringWithSpecial(values, value) {
  const regex = /^[-@.'\/#&+\w\s]*$/;
  return regex.test(value || '');
}
